import { render, staticRenderFns } from "./changeLogo.vue?vue&type=template&id=22a18f4e&scoped=true&"
import script from "./changeLogo.vue?vue&type=script&lang=ts&"
export * from "./changeLogo.vue?vue&type=script&lang=ts&"
import style0 from "./changeLogo.vue?vue&type=style&index=0&id=22a18f4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a18f4e",
  null
  
)

export default component.exports